import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Preloader from "../components/Preloader";
import MagnetCursor from "../components/MagnetCursor";
import ScrollToTop from "../components/ScrollToTop";

const SERVICES_API = "https://backenddev.aaerlaw.com/api/user/paraclearth_services";

function Service() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const preloader = document.getElementById("preloader");
    if (preloader) preloader.style.display = "none";
  }, []);

  useEffect(() => {
    if (window.jarallax) {
      window.jarallax(document.querySelectorAll(".jarallax"), { speed: 0.6 });
    }
  }, []);

  useEffect(() => {
    fetch(`${SERVICES_API}?page=1&limit=50`)
      .then((res) => res.json())
      .then((json) => {
        if (Array.isArray(json?.data)) setServices(json.data);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      {/* Preloader */}
      <Preloader />

      {/* Breadcrumb Section */}
      <div
        className="breadcrumb-section breadcrumb-compact bg-img jarallax"
        data-jarallax=""
        data-speed="0.6"
        style={{ backgroundImage: "url('assets/img/bg-img/73.jpg')" }}
      >
        <div className="divider"></div>
        <div className="container">
          <div className="breadcrumb-content">
            <h2
              className="wow fadeInUp"
              data-wow-duration="1000ms"
              data-wow-delay="700ms"
            >
              Our Services
            </h2>
            <ul
              className="list-unstyled wow fadeInUp"
              data-wow-duration="1000ms"
              data-wow-delay="1000ms"
            >
              <li>
                <Link className="magnet-link" to="/">
                  Home
                </Link>
              </li>
              <li>Our Services</li>
            </ul>
          </div>
        </div>
        <div className="divider"></div>
      </div>

      {/* Services Grid */}
      <section className="service-section bg-white">
        <div className="divider"></div>

        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-md-8 col-lg-7">
              <div className="section-heading text-center">
                <div className="sub-title justify-content-center">
                  <img src="assets/img/core-img/hammer.png" alt="" />
                  Our Services
                </div>
                <h2>People do not Win Cases, Lawyers Do</h2>
              </div>
            </div>
          </div>

          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-secondary" role="status">
                <span className="visually-hidden">Loading&hellip;</span>
              </div>
            </div>
          ) : services.length === 0 ? (
            <div className="text-center py-5">
              <p>No services available.</p>
            </div>
          ) : (
            <div className="row g-4 mt-2">
              {services.map((s) => (
                <div key={s.id} className="col-12 col-sm-6 col-md-4">
                  <div
                    className="service-grid-card h-100 p-4"
                  >
                    {s.icon && (
                      <div
                        className="mb-3"
                        style={{ fontSize: "32px", color: "#1c1d20" }}
                      >
                        <i className={s.icon}></i>
                      </div>
                    )}
                    <div className="h5 mb-2">{s.title}</div>
                    {s.summary && (
                      <p
                        className="mb-3"
                        style={{ color: "#555", fontSize: "14px" }}
                      >
                        {s.summary}
                      </p>
                    )}
                    <Link
                      to={`/servicedetails?id=${s.id}`}
                      className="btn btn-sm btn-primary"
                    >
                      <span>
                        Read More <i className="ti ti-arrow-up-right"></i>
                      </span>
                      <span>
                        Read More <i className="ti ti-arrow-up-right"></i>
                      </span>
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="divider"></div>
      </section>

      {/* Scroll To Top */}
      <ScrollToTop />

      {/* Magnet Cursor */}
      <MagnetCursor />
    </div>
  );
}

export default Service;
